
export async function steamCall(...args) {
	const response = await window['bridge'].DiebraryToElectronSteam(() => { }, ...args)
	console.log(`Steam response: `, response)
	return response
}
